import { exists } from '@/api'

export interface GroupMember {
  numberOfGroupMembers: number
  numberOfGroupChildren: number
}

export function GroupMemberFromJSON(json: any): GroupMember {
  return {
    numberOfGroupMembers: exists(json, 'number_of_group_members')
      ? json.number_of_group_members
      : 0,
    numberOfGroupChildren: exists(json, 'number_of_group_children')
      ? json.number_of_group_children
      : 0
  }
}

export const defaultGroupMember = (): GroupMember => ({
  numberOfGroupMembers: 0,
  numberOfGroupChildren: 0
})
